import React from "react";
import { Select } from "antd";
import "antd/dist/antd.css";
import { IoMdArrowDropdown } from "react-icons/io";

const { Option } = Select;

export default function SelectFilterClear({ headerSelectFilterClear }) {
  function handleChange(value) {
    // console.log(value);
  }
  return (
    <div className="div-DatePicker-style-custom">
      <p className="text-header-date-picker"> {headerSelectFilterClear} </p>
      <Select
        onChange={handleChange}
        style={{ width: "100%" }}
        allowClear
        suffixIcon={
          <IoMdArrowDropdown
            style={{ fontSize: "1.7rem", marginLeft: "-20px" }}
          />
        }
      >
        <Option value="AAA">AAA</Option>
        <Option value="BBB">BBB</Option>
        <Option value="CCC">CCC</Option>
      </Select>
    </div>
  );
}
